import { TRANSCRIPT_SEGMENT_STATUS } from '../types/transcriptSegment'

export function buildTranscriptPreview(segments = []) {
	if (!Array.isArray(segments) || segments.length === 0) {
		return ''
	}

	return segments
		.filter(
			segment =>
				segment?.status === TRANSCRIPT_SEGMENT_STATUS.FINAL &&
				String(segment.text || '').trim(),
		)
		.sort((a, b) => a.chunkId - b.chunkId)
		.map(segment => String(segment.text).trim())
		.join(' ')
}
